import type { CatalogPet, CatalogResponse, CatalogSort } from "./catalog-feed";

export interface CatalogClientQuery { page: number; pageSize: number; sort: CatalogSort; q: string }

export function buildCatalogUrl(query: CatalogClientQuery): string {
  const params = new URLSearchParams();
  params.set("page", String(query.page));
  params.set("pageSize", String(query.pageSize));
  params.set("sort", query.sort);
  if (query.q.trim()) params.set("q", query.q.trim());
  return `/api/catalog?${params.toString()}`;
}

export async function fetchCatalog(query: CatalogClientQuery, signal?: AbortSignal): Promise<CatalogResponse> {
  const response = await fetch(buildCatalogUrl(query), { signal });
  if (!response.ok) throw new Error(`catalog request failed: ${response.status}`);
  return response.json() as Promise<CatalogResponse>;
}

export type { CatalogPet, CatalogResponse, CatalogSort };
